export enum MuteScenariosReason {
  Absence = 'Absence',
  Visitor = 'Visitor',
}
